import { createApp } from 'vue';

import App from './App.vue';
import router from "./router";
import store from "./store/index.js";
import BaseSpinner from './components/ui/BaseSpinner.vue';
import '@fortawesome/fontawesome-free/css/all.min.css'



const app = createApp(App);

app.use(store);
app.use(router);

app.component('base-spinner', BaseSpinner);

app.mount('#app');
